// AUTO-GENERATED — DO NOT EDIT.
// Regenerated by scripts/generate-entries.mjs on every build and in watch mode.
// Edit the source partials/modules instead; this file is gitignored.

import * as m_0_global_media_size from './0_global/media_size.js';
import * as m_0_global_scrollbar_size from './0_global/scrollbar_size.js';
import * as m_0_global_shop_map from './0_global/shop_map.js';
import * as m_0_global_translations from './0_global/translations.js';
import * as m_1_utils_custom_resize from './1_utils/custom_resize.js';
import * as m_1_utils_delivery_date from './1_utils/delivery_date.js';
import * as m_1_utils_expanded_toggle from './1_utils/expanded_toggle.js';
import * as m_1_utils_go_top_btn from './1_utils/go_top_btn.js';
import * as m_1_utils_measure_units_download from './1_utils/measure_units_download.js';
import * as m_1_utils_raventic_config from './1_utils/raventic_config.js';
import * as m_1_utils_scroll_to_element from './1_utils/scroll_to_element.js';
import * as m_1_utils_slider_custom from './1_utils/slider_custom.js';
import * as m_1_utils_top_right_position_fixed_components from './1_utils/top_right_position_fixed_components.js';
import * as m_2_components_breadcrumbs from './2_components/breadcrumbs.js';
import * as m_2_components_carousel from './2_components/carousel.js';
import * as m_2_components_cart_widget from './2_components/cart_widget.js';
import * as m_2_components_cbox from './2_components/cbox.js';
import * as m_2_components_delivery_tooltip from './2_components/delivery_tooltip.js';
import * as m_2_components_dklab_compare from './2_components/dklab_compare.js';
import * as m_2_components_dklab_favorites from './2_components/dklab_favorites.js';
import * as m_2_components_footer_bottom from './2_components/footer_bottom.js';
import * as m_2_components_footer_instagram from './2_components/footer_instagram.js';
import * as m_2_components_gift_coupon from './2_components/gift_coupon.js';
import * as m_2_components_header_left_to_free_shipping from './2_components/header_left_to_free_shipping.js';
import * as m_2_components_header from './2_components/header.js';
import * as m_2_components_login_widget from './2_components/login_widget.js';
import * as m_2_components_measure_units_show from './2_components/measure_units_show.js';
import * as m_2_components_menu from './2_components/menu.js';
import * as m_2_components_page_title from './2_components/page_title.js';
import * as m_2_components_phone_input from './2_components/phone_input.js';
import * as m_2_components_product_sets from './2_components/product_sets.js';
import * as m_2_components_product_variants from './2_components/product_variants.js';
import * as m_2_components_products_block_amount_to_cart from './2_components/products_block_amount_to_cart.js';
import * as m_2_components_products_block_reviews_number from './2_components/products_block_reviews_number.js';
import * as m_2_components_products_block_slider from './2_components/products_block_slider.js';
import * as m_2_components_products_block_standard_price from './2_components/products_block_standard_price.js';
import * as m_2_components_products_block_swap_images from './2_components/products_block_swap_images.js';
import * as m_2_components_qr_calendar_modal from './2_components/qr_calendar_modal.js';
import * as m_2_components_reset_focus from './2_components/reset_focus.js';
import * as m_2_components_search_raventic_dropdown_setup_new from './2_components/search_raventic_dropdown_setup_new.js';
import * as m_2_components_search_raventic_dropdown_setup from './2_components/search_raventic_dropdown_setup.js';
import * as m_2_components_search_raventic_results_setup_new from './2_components/search_raventic_results_setup_new.js';
import * as m_2_components_search_raventic_results_setup from './2_components/search_raventic_results_setup.js';
import * as m_2_components_share_modal from './2_components/share_modal.js';
import * as m_2_components_slovnik_pojmu from './2_components/slovnik_pojmu.js';
import * as m_3_pages_acount_pages from './3_pages/acount_pages.js';
import * as m_3_pages_blog from './3_pages/blog.js';
import * as m_3_pages_brand_page from './3_pages/brand_page.js';
import * as m_3_pages_category_crossell from './3_pages/category_crossell.js';
import * as m_3_pages_category_filters from './3_pages/category_filters.js';
import * as m_3_pages_category_move_elements from './3_pages/category_move_elements.js';
import * as m_3_pages_delivery_and_payment from './3_pages/delivery_and_payment.js';
import * as m_3_pages_empty_cart from './3_pages/empty_cart.js';
import * as m_3_pages_index from './3_pages/index.js';
import * as m_3_pages_kariera from './3_pages/kariera.js';
import * as m_3_pages_natios_manual from './3_pages/natios_manual.js';
import * as m_3_pages_ordering_process_0_repeating from './3_pages/ordering_process_0_repeating.js';
import * as m_3_pages_ordering_process_1 from './3_pages/ordering_process_1.js';
import * as m_3_pages_ordering_process_2 from './3_pages/ordering_process_2.js';
import * as m_3_pages_ordering_process_3 from './3_pages/ordering_process_3.js';
import * as m_3_pages_product_edit_detail_params_urls from './3_pages/product_edit_detail_params_urls.js';
import * as m_3_pages_product_product_top from './3_pages/product_product_top.js';
import * as m_3_pages_product_related_files from './3_pages/product_related_files.js';
import * as m_3_pages_product_related from './3_pages/product_related.js';
import * as m_3_pages_product_reviews from './3_pages/product_reviews.js';
import * as m_3_pages_product_supporting_bottom from './3_pages/product_supporting_bottom.js';
import * as m_3_pages_product_table_explanation from './3_pages/product_table_explanation.js';
import * as m_3_pages_product_tabs from './3_pages/product_tabs.js';
import * as m_3_pages_search_luigi from './3_pages/search_luigi.js';
import * as m_3_pages_search_raventic_results from './3_pages/search_raventic_results.js';
import * as m_3_pages_thank_you from './3_pages/thank_you.js';
import * as z_template_folder_template_file from './z_template_folder/template_file.js';

// Each module's init() is called immediately at load (no DOMContentLoaded wrapper).
// The bundle uses `defer`, so the DOM is already parsed by the time this runs.
// A module that needs a later moment should handle that itself (e.g. listen for
// 'load' inside its own init()).
const modules = [
  { name: '0_global/media_size.js', mod: m_0_global_media_size },
  { name: '0_global/scrollbar_size.js', mod: m_0_global_scrollbar_size },
  { name: '0_global/shop_map.js', mod: m_0_global_shop_map },
  { name: '0_global/translations.js', mod: m_0_global_translations },
  { name: '1_utils/custom_resize.js', mod: m_1_utils_custom_resize },
  { name: '1_utils/delivery_date.js', mod: m_1_utils_delivery_date },
  { name: '1_utils/expanded_toggle.js', mod: m_1_utils_expanded_toggle },
  { name: '1_utils/go_top_btn.js', mod: m_1_utils_go_top_btn },
  { name: '1_utils/measure_units_download.js', mod: m_1_utils_measure_units_download },
  { name: '1_utils/raventic_config.js', mod: m_1_utils_raventic_config },
  { name: '1_utils/scroll_to_element.js', mod: m_1_utils_scroll_to_element },
  { name: '1_utils/slider_custom.js', mod: m_1_utils_slider_custom },
  { name: '1_utils/top_right_position_fixed_components.js', mod: m_1_utils_top_right_position_fixed_components },
  { name: '2_components/breadcrumbs.js', mod: m_2_components_breadcrumbs },
  { name: '2_components/carousel.js', mod: m_2_components_carousel },
  { name: '2_components/cart_widget.js', mod: m_2_components_cart_widget },
  { name: '2_components/cbox.js', mod: m_2_components_cbox },
  { name: '2_components/delivery_tooltip.js', mod: m_2_components_delivery_tooltip },
  { name: '2_components/dklab_compare.js', mod: m_2_components_dklab_compare },
  { name: '2_components/dklab_favorites.js', mod: m_2_components_dklab_favorites },
  { name: '2_components/footer_bottom.js', mod: m_2_components_footer_bottom },
  { name: '2_components/footer_instagram.js', mod: m_2_components_footer_instagram },
  { name: '2_components/gift_coupon.js', mod: m_2_components_gift_coupon },
  { name: '2_components/header_left_to_free_shipping.js', mod: m_2_components_header_left_to_free_shipping },
  { name: '2_components/header.js', mod: m_2_components_header },
  { name: '2_components/login_widget.js', mod: m_2_components_login_widget },
  { name: '2_components/measure_units_show.js', mod: m_2_components_measure_units_show },
  { name: '2_components/menu.js', mod: m_2_components_menu },
  { name: '2_components/page_title.js', mod: m_2_components_page_title },
  { name: '2_components/phone_input.js', mod: m_2_components_phone_input },
  { name: '2_components/product_sets.js', mod: m_2_components_product_sets },
  { name: '2_components/product_variants.js', mod: m_2_components_product_variants },
  { name: '2_components/products_block_amount_to_cart.js', mod: m_2_components_products_block_amount_to_cart },
  { name: '2_components/products_block_reviews_number.js', mod: m_2_components_products_block_reviews_number },
  { name: '2_components/products_block_slider.js', mod: m_2_components_products_block_slider },
  { name: '2_components/products_block_standard_price.js', mod: m_2_components_products_block_standard_price },
  { name: '2_components/products_block_swap_images.js', mod: m_2_components_products_block_swap_images },
  { name: '2_components/qr_calendar_modal.js', mod: m_2_components_qr_calendar_modal },
  { name: '2_components/reset_focus.js', mod: m_2_components_reset_focus },
  { name: '2_components/search_raventic_dropdown_setup_new.js', mod: m_2_components_search_raventic_dropdown_setup_new },
  { name: '2_components/search_raventic_dropdown_setup.js', mod: m_2_components_search_raventic_dropdown_setup },
  { name: '2_components/search_raventic_results_setup_new.js', mod: m_2_components_search_raventic_results_setup_new },
  { name: '2_components/search_raventic_results_setup.js', mod: m_2_components_search_raventic_results_setup },
  { name: '2_components/share_modal.js', mod: m_2_components_share_modal },
  { name: '2_components/slovnik_pojmu.js', mod: m_2_components_slovnik_pojmu },
  { name: '3_pages/acount_pages.js', mod: m_3_pages_acount_pages },
  { name: '3_pages/blog.js', mod: m_3_pages_blog },
  { name: '3_pages/brand_page.js', mod: m_3_pages_brand_page },
  { name: '3_pages/category_crossell.js', mod: m_3_pages_category_crossell },
  { name: '3_pages/category_filters.js', mod: m_3_pages_category_filters },
  { name: '3_pages/category_move_elements.js', mod: m_3_pages_category_move_elements },
  { name: '3_pages/delivery_and_payment.js', mod: m_3_pages_delivery_and_payment },
  { name: '3_pages/empty_cart.js', mod: m_3_pages_empty_cart },
  { name: '3_pages/index.js', mod: m_3_pages_index },
  { name: '3_pages/kariera.js', mod: m_3_pages_kariera },
  { name: '3_pages/natios_manual.js', mod: m_3_pages_natios_manual },
  { name: '3_pages/ordering_process_0_repeating.js', mod: m_3_pages_ordering_process_0_repeating },
  { name: '3_pages/ordering_process_1.js', mod: m_3_pages_ordering_process_1 },
  { name: '3_pages/ordering_process_2.js', mod: m_3_pages_ordering_process_2 },
  { name: '3_pages/ordering_process_3.js', mod: m_3_pages_ordering_process_3 },
  { name: '3_pages/product_edit_detail_params_urls.js', mod: m_3_pages_product_edit_detail_params_urls },
  { name: '3_pages/product_product_top.js', mod: m_3_pages_product_product_top },
  { name: '3_pages/product_related_files.js', mod: m_3_pages_product_related_files },
  { name: '3_pages/product_related.js', mod: m_3_pages_product_related },
  { name: '3_pages/product_reviews.js', mod: m_3_pages_product_reviews },
  { name: '3_pages/product_supporting_bottom.js', mod: m_3_pages_product_supporting_bottom },
  { name: '3_pages/product_table_explanation.js', mod: m_3_pages_product_table_explanation },
  { name: '3_pages/product_tabs.js', mod: m_3_pages_product_tabs },
  { name: '3_pages/search_luigi.js', mod: m_3_pages_search_luigi },
  { name: '3_pages/search_raventic_results.js', mod: m_3_pages_search_raventic_results },
  { name: '3_pages/thank_you.js', mod: m_3_pages_thank_you },
  { name: 'z_template_folder/template_file.js', mod: z_template_folder_template_file },
];

for (const { name, mod } of modules) {
  // Modules exporting init() run automatically; those without it are still
  // bundled above for their side effects. Each call is isolated so one failure
  // does not stop the rest — and the error names the offending module.
  try {
    mod.init?.();
  } catch (err) {
    console.error(`[main] module "${name}" init() failed:`, err);
  }
}
